export const categories = [
  {
    id: 1,
    name: 'Jewellery',
    description: 'Stunning resin earrings, necklaces, and rings crafted with vibrant colors and unique designs',
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/Photoroom-20240526-145800.png?v=1716699611&width=800',
    link: '/jewellery'
  },
  {
    id: 2,
    name: 'Homewares',
    description: 'Decorative bowls, coasters, and functional pieces that bring artistic flair to any room',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/20260215-141230.jpg?v=1771125498',
    link: '/homewares'
  },
  {
    id: 3,
    name: 'Beaded Pens',
    description: 'Beautifully crafted beaded pens that add elegance and charm to your writing',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/20250909-170553.png?v=1757403967',
    link: '/beaded-pens'
  }
];

export const productTypes = [
  {
    id: 1,
    name: 'Keycharms',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/Photoroom_20251229_120018_360x.png?v=1767002313',
    link: '/keycharms'
  },
  {
    id: 2,
    name: 'Earrings',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/Photoroom_20251229_112337_4_360x.png?v=1767002361',
    link: '/earrings'
  },
  {
    id: 3,
    name: 'Pendants',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/Photoroom_20251229_114507_360x.png?v=1767002371',
    link: '/pendants'
  },
  {
    id: 4,
    name: 'Bracelets',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/Photoroom_20251229_115538_360x.png?v=1767002321',
    link: '/bracelets'
  },
  {
    id: 5,
    name: 'Lapel Pins',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/Photoroom_20251229_115038_360x.png?v=1767002373',
    link: '/lapel-pins'
  },
  {
    id: 6,
    name: 'Hair Clips',
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/20251210-155824_360x.jpg?v=1765356387',
    link: '/hair-clips'
  }
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Pink & Gold Water Drop Earrings',
    price: 15.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/Photoroom-20240526-145800.png?v=1716699611&width=533',
    inStock: true,
    link: '/product/earrings-dangling-pink-and-gold-water-drop-1'
  },
  {
    id: 2,
    name: 'Butterfly Dangling Earrings',
    price: 15.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/Photoroom-20240502-113435.png?v=1714614014&width=533',
    inStock: true,
    link: '/product/earrings-dangling-butterflies'
  },
  {
    id: 3,
    name: 'Fairy Dangling Earrings',
    price: 25.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/Photoroom-20240501-145609.png?v=1714540148&width=533',
    inStock: true,
    link: '/product/earrings-large-dangling-fairy'
  },
  {
    id: 4,
    name: 'Blue Starfish Earrings',
    price: 15.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/140bb738-3334-4d77-b4a8-de1e95952b19.jpg?v=1762585451&width=533',
    inStock: true,
    link: '/product/earrings-dangling-blue-starfish'
  },
  {
    id: 5,
    name: 'Gold Mermaid Scale Earrings',
    price: 15.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/IMG_7091.png?v=1762508670&width=533',
    inStock: true,
    link: '/product/earrings-dangling-gold-mermaid-scales'
  },
  {
    id: 6,
    name: 'Color Changing Earrings',
    price: 17.90,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/IMG_7092.jpg?v=1762508759&width=533',
    inStock: true,
    link: '/product/earrings-colour-changing'
  },
  {
    id: 7,
    name: 'Seashell Earrings',
    price: 15.00,
    image: 'https://cdn.shopify.com/s/files/1/0746/9442/6899/files/20251210-155824_360x.jpg?v=1765356387',
    inStock: true,
    link: '/product/earrings-seashell'
  },
  {
    id: 8,
    name: 'Turquoise Purple Earrings',
    price: 20.00,
    image: 'https://charmingcreationsgifts.myshopify.com/cdn/shop/files/Photoroom-20240611-171550.png?v=1718090349&width=533',
    inStock: true,
    link: '/product/earrings-dangling-turquoise-purple'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    rating: 5,
    text: 'Absolutely stunning pieces! The attention to detail in each earring is incredible. I get compliments every time I wear them.',
    avatar: 'SM'
  },
  {
    id: 2,
    name: 'Emily Chen',
    rating: 5,
    text: 'The quality of these handcrafted resin pieces is exceptional. Each item is truly unique and makes a perfect gift.',
    avatar: 'EC'
  },
  {
    id: 3,
    name: 'Jessica Brown',
    rating: 5,
    text: 'I love supporting small businesses that create such beautiful art. The colors are vibrant and the craftsmanship is top-notch!',
    avatar: 'JB'
  }
];